'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import FacebookPixel from '@/utils/facebookPixel';

export default function FacebookPixelProvider() {
  const pathname = usePathname();

  useEffect(() => {
    FacebookPixel.init();
    FacebookPixel.pageView();
  }, []);

  useEffect(() => {
    FacebookPixel.pageView();
  }, [pathname]);

  return null;
}
